<template>
  <div v-if="failedStatus">
    <label class="font-weight-light">
      {{ $t('redemption-history-disbursement-delivery-status-label') }}
    </label>
    <v-icon
      :color="color"
      small
    >
      {{ icon }}
    </v-icon>
    <span class="status-label">
      {{ label }}
    </span>
    <p
      v-if="showDescription"
      class="my-2 status-description"
    >
      {{ description }}
    </p>
  </div>
  <div v-else>
    <span
      id="payment-delivery-label"
      class="font-weight-bold"
    >
      {{ $t('redemption-history-payment-delivery-label') }}
    </span>
    <p>
      <v-chip
        id="payment-delivery-chip"
        class="font-weight-bold pl-4 pr-4"
        :small="$vuetify.breakpoint.xsOnly"
        :color="chipColor"
        v-text="paymentFulfillmentLabel"
      />
    </p>
  </div>
</template>

<script>
import { IsFailedStatuses } from '@/store/classes/delivery-status'
import { TangoCardColors } from '@tangocard/swag'
import { ItemRewardType } from '@/cowboy/EnumTypes'
import { RedeemedItem } from '@/store/classes/redeemed-item'

export default {
  name: 'DisbursementDeliveryStatus',
  props: {
    showDescription: {
      type: Boolean,
      default: false
    },
    item: {
      type: RedeemedItem,
      required: true
    }
  },
  computed: {
    chipColor: () => TangoCardColors.orange_500,
    paymentFulfillmentLabel () {
      if (
        ItemRewardType.PAYMENT_DEBIT_CARD === this.item.rewardType
      ) {
        return this.$t('reward-payment-debit-fulfillment')
      } else {
        return this.$t('reward-payment-ach-fulfillment')
      }
    },
    failed () {
      return {
        label: this.$t('redemption-history-disbursement-delivery-failed-status-label'),
        description: this.failedDescription,
        color: 'error',
        icon: 'mdi-close-circle'
      }
    },
    failedDescription () {
      if (ItemRewardType.PAYMENT_DEBIT_CARD === this.item.rewardType) {
        return this.$t('redemption-history-disbursement-delivery-card-status-failed')
      } else {
        return this.$t('redemption-history-disbursement-delivery-ach-status-failed')
      }
    },
    failedStatus () {
      if (IsFailedStatuses.includes(this.item.deliveryStatus)) {
        return this.failed
      } else {
        return null
      }
    },
    label () {
      const { label } = this.failedStatus || {}
      return label
    },
    description () {
      const { description } = this.failedStatus || {}
      return description
    },
    color () {
      const { color } = this.failedStatus || {}
      return color
    },
    icon () {
      const { icon } = this.failedStatus || {}
      return icon
    }
  }
}
</script>
